import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema, defaultObject} from '/vercel/path0/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/vercel/path0/markdoc/tags/index.ts'
import * as nodes from '/vercel/path0/markdoc/nodes/index.ts'
const functions = {};
const schema = {
tags: defaultObject(tags),
nodes: defaultObject(nodes),
functions: defaultObject(functions),
...defaultObject(config),
};

const tokenizer = new Markdoc.Tokenizer();

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ntitle: Covalent Partners with Fantom Integrating its Indexing Solution with the Highly Scalable Blockchain Ecosystem\ndate: 2021-03-23T04:25:15-04:00\ncategories: [\"ecosystem\"]\ndescription: Covalent Announces Integration with Fantom\nauthor: niall\nsubbrand_image: https://www.covalenthq.com/static/images/blog/202103/fantom.jpg\ntype: legacy\n---\n\n**VANCOUVER, March 23rd, 2021** - Covalent is delighted to announce a technical partnership with Fantom, a high-performance, scalable, customizable, and secure smart-contract platform.\n\n\n\nFounded in 2018, Fantom is designed to overcome the limitations of previous-generation blockchain platforms. Fantom is permissionless, decentralized, and open-source while achieving fast finality (1-2 second transaction confirmation) and low fees ($0.00001). Furthermore, Fantom is EVM-compatible.\n\nWhen examining how to overcome the data accessibility issue on blockchain networks, Fantom knew a best-in-class API would be needed given that builders require such when developing applications. By integrating Covalent’s indexing solution, developers will be able to pull Fantom blockchain data seamlessly. This includes:\n\n- Token balances per address\n- Historical transactions per address\n- Historical prices by address and ticker symbol\n- Decoded log events\n\nQuerying the Fantom blockchain will be as simple as changing one parameter on the Covalent API; chainId. Also, integrating with Covalent allows builders from the Ethereum ecosystem to re-purpose their technology for Fantom.\n\n\n## Quote from Michael Kong, Fantom CEO\n\n\n \n \"\n We’re excited to provide builders with the tools necessary to build applications that work in a multi-chain setting. Wallets, aggregators, and many others are using Covalent to support new chains such as Fantom, opening the gates to the next wave of users.\n \n\n\n## Quote from Ganesh, Covalent CEO\n\n\n \n \"\n Fantom is an exceptional platform that is cutting no corners in tackling the blockchain trilemma. What’s particularly interesting about Fantom is the DeFi stack that is being developed. Reliable, high-quality data is vital to building performant DeFi applications. Each developer building on Fantom will now have such through Covalent.\n \n\n\n## About Fantom\n\nFounded in 2018, The Fantom Foundation has built a highly scalable blockchain ecosystem that facilitates decentralized, scalable, and secure technologies.\n\nFantom is a fast, scalable, and secure layer-1 platform built on a permissionless aBFT consensus protocol. The speed, low transaction costs, and high throughput make Fantom ideal for DeFi applications and real-world uses.\n\nMany Ethereum protocols are porting over to Fantom to create a seamless cross-chain ecosystem. These include Keep3rV1, Cover, Cream, Frax, Sushiswap, Yearn, and others.\nThe technology is also used in several government digitization programs in the Middle East.\n\n[Website](https://www.fantom.foundation/) | [Tech papers](https://fantom.foundation/fantom-research-papers/) | [Discord](http://chat.fantom.network/) | [Blog](https://fantom.foundation/blog/) | [Twitter](https://twitter.com/FantomFDN) | [Reddit](https://www.reddit.com/r/FantomFoundation/) | [Github](https://github.com/Fantom-Foundation)\n\n\n\n\n";
const filepath = "/blog/fantom-announcement.md";
const tokens = tokenizer.tokenize(source);
const ast = Markdoc.parse(tokens);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    const tokens = tokenizer.tokenize(partials[key]);
    partials[key] = Markdoc.parse(tokens);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = await Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
